<template>
  <v-container>
    <v-row>
      <v-col>
        <create-form @submitForm="submitData" v-if="data.dots_enddate==null" />
        <v-card v-else>
          <v-card-title>Your DOT Activity has been finished on {{ data.dots_enddate }}</v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <list :datas="datas"></list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import List from "@/components/dots/DotsVolunteer/List.vue";
import CreateForm from "@/components/dots/DotsVolunteer/CreateForm.vue";
export default {
  created() {
    this.$store.dispatch("DotsPatient/getEach", {
      column: "id",
      value: this.$route.params.id
    });
    this.$store.dispatch("DotsVolunteer/getAll", {
      dots_patient_id: this.$route.params.id
    });
  },
  computed: {
    ...mapState("DotsVolunteer", ["datas"]),
    ...mapState("DotsPatient", ["data"])
  },
  components: {
    List,
    CreateForm
  },
  methods: {
    submitData(data) {
      this.$store.dispatch("DotsVolunteer/save", {
        dots_patient_id: this.$route.params.id,
        date: data.date,
        volunteer_id: data.volunteer_id,
        dots_app_status: data.dots_app_status
      });
    }
  }
};
</script>

<style>
</style>